import { FunctionComponent } from 'react';
import * as s from './ErrorMessage.css';
import * as T from './ErrorMessage.types';
import Text from '@media-ui/core/src/components/Text';
export const ErrorMessage: FunctionComponent<T.IErrorMessage> = ({ message = 'Нельзя добавить больше 15 питомцев', }) => {
    return (<div className={s.root}>
      <Text className={s.message}>{message}</Text>
    </div>);
};
